// extracted by mini-css-extract-plugin
export default {"card":"Card_card__5FTnX","typeIcon":"Card_typeIcon__0zSy2","mask":"Card_mask__dGt5h"};